<template lang="pug">
.profile
  //- ============ HERO ============
  header.profile__hero
    .profile__hero-grid
    .profile__hero-glow.profile__hero-glow--blue
    .profile__hero-glow.profile__hero-glow--red
    .profile__hero-inner
      p.profile__eyebrow
        span.profile__eyebrow-pip
        | Meu perfil
      .profile__head
        .profile__avatar
          img.profile__avatar-img(v-if="avatarImage" :src="avatarImage" alt="")
          span(v-else-if="userInitials") {{ userInitials }}
          FontAwesomeIcon(v-else :icon="['fas', 'user']")
        .profile__identity
          h1.profile__name {{ takeUser.name || 'Usuário' }}
          .profile__meta
            span.profile__meta-item(v-if="takeUser.username")
              FontAwesomeIcon.profile__meta-ic(:icon="['fas', 'at']")
              | {{ takeUser.username }}
            span.profile__meta-item(v-if="takeUser.email")
              FontAwesomeIcon.profile__meta-ic(:icon="['far', 'envelope']")
              | {{ takeUser.email }}
            span.profile__id(v-if="takeUser.id") ID {{ takeUser.id }}
          .profile__roles
            span.profile__role(v-for="(p, i) in takePermissions" :key="i")
              FontAwesomeIcon.profile__role-ic(:icon="permIcon(p)")
              | {{ p }}
            span.profile__role.profile__role--muted(v-if="!takePermissions.length")
              FontAwesomeIcon.profile__role-ic(:icon="['fas', 'user']")
              | Competidor
            span.profile__role(v-if="isCaptain")
              FontAwesomeIcon.profile__role-ic(:icon="['fas', 'star']")
              | Capitão

  .profile__wrap
    //- ============ AÇÕES DE GESTÃO ============
    section.profile__section(v-if="canManage")
      h2.profile__section-title Ações de gestão
      .profile__actions
        button.actcard(@click="doShowModalEditProfile")
          span.actcard__ic
            FontAwesomeIcon(:icon="['fas', 'edit']")
          span.actcard__txt
            strong Editar perfil
            span Alterar nome, e-mail ou senha
          FontAwesomeIcon.actcard__arrow(:icon="['fas', 'arrow-right']")
        button.actcard(@click="doShowModalPermission")
          span.actcard__ic
            FontAwesomeIcon(:icon="['fas', 'user-shield']")
          span.actcard__txt
            strong Conceder permissão
            span Atribuir papéis a um usuário
          FontAwesomeIcon.actcard__arrow(:icon="['fas', 'arrow-right']")
        button.actcard(@click="doShowModalGenerateKeys")
          span.actcard__ic
            FontAwesomeIcon(:icon="['fas', 'sitemap']")
          span.actcard__txt
            strong Gerar chaves
            span Sortear a chave de uma categoria
          FontAwesomeIcon.actcard__arrow(:icon="['fas', 'arrow-right']")
        button.actcard(@click="doShowModalAddTeam")
          span.actcard__ic
            FontAwesomeIcon(:icon="['fas', 'users']")
          span.actcard__txt
            strong Adicionar equipe
            span Cadastrar uma nova equipe
          FontAwesomeIcon.actcard__arrow(:icon="['fas', 'arrow-right']")
        button.actcard(@click="doShowModalAddRobot")
          span.actcard__ic
            FontAwesomeIcon(:icon="['fas', 'robot']")
          span.actcard__txt
            strong Adicionar robô
            span Cadastrar um novo robô
          FontAwesomeIcon.actcard__arrow(:icon="['fas', 'arrow-right']")

    //- ============ COMPETIDOR (sem gestão) ============
    section.profile__section(v-else)
      h2.profile__section-title Sua conta
      .profile__actions
        button.actcard(@click="doShowModalEditProfile")
          span.actcard__ic
            FontAwesomeIcon(:icon="['fas', 'edit']")
          span.actcard__txt
            strong Editar perfil
            span Alterar nome, e-mail ou senha
          FontAwesomeIcon.actcard__arrow(:icon="['fas', 'arrow-right']")
        button.actcard(@click="doNavigate('MinhaEquipe')")
          span.actcard__ic
            FontAwesomeIcon(:icon="['fas', 'users']")
          span.actcard__txt
            strong Minha equipe
            span {{ hasTeam ? 'Ver e gerenciar sua equipe' : 'Criar e montar sua equipe' }}
          FontAwesomeIcon.actcard__arrow(:icon="['fas', 'arrow-right']")
      .profile__hint
        span.profile__hint-ic
          FontAwesomeIcon(:icon="['fas', 'flag-checkered']")
        .profile__hint-txt
          strong Você está participando como competidor
          span Acompanhe eventos, chaves e lutas pelos atalhos no topo da página.
        button.profile__hint-btn(@click="doNavigate('Eventos')")
          span Ver eventos
          FontAwesomeIcon.profile__hint-btn-ic(:icon="['fas', 'arrow-right']")

    Modal(
      :visible="showModal"
      @close="doSetModalVisibility"
      @emit="doSetModalVisibility"
    )
      .pmodal
        .pmodal__step(v-if="step === 0")
          h3.pmodal__title Conceder permissão
          label.pmodal__label(for="pf-userid") Id do usuário
          input#pf-userid.pmodal__input(
            type="number"
            min="1"
            placeholder="Digite o Id do usuário"
            v-model.number="userId"
          )
          p.pmodal__err(v-if="permError") {{ permError }}
          .pmodal__foot
            Button(
              text="Próximo"
              border="base"
              @click="doPassStep"
            )

        .pmodal__step(v-if="step === 1")
          h3.pmodal__title Funções
          .pmodal__checks
            Check(
              v-for="(option, index) in takeRoles"
              :key="index"
              :value="{ text: option.name, id: option.id }"
              @change="doSetRoles"
            )
          p.pmodal__err(v-if="permError") {{ permError }}
          .pmodal__foot
            Button(
              text="Confirmar"
              border="base"
              @click="doGrantPermission"
            )

        .pmodal__step(v-if="step === 2")
          h3.pmodal__title Gerar chaves
          label.pmodal__label Categoria
          Select.pmodal__select(
            defaultText="Selecionar categoria"
            :options="takeCategories"
            type='drop'
            @emit="doSetSelectedCategory"
          )
          .pmodal__foot
            Button(
              text="Confirmar"
              border="base"
              @click="doGenerateKeys"
            )

        .pmodal__step(v-if="step === 3")
          h3.pmodal__title Editar perfil
          .pmodal__photo
            .pmodal__photo-preview
              img(v-if="avatarImage" :src="avatarImage" alt="")
              FontAwesomeIcon(v-else :icon="['fas', 'user']")
            label.pmodal__photo-btn
              FontAwesomeIcon(:icon="['fas', 'image']")
              | {{ avatarImage ? 'Trocar foto' : 'Adicionar foto' }}
              input.pmodal__photo-input(type="file" accept="image/*" @change="doSelectAvatar")
          label.pmodal__label Nome
          input.pmodal__input(
            type="text"
            placeholder="Seu nome"
            v-model="editName"
          )
          label.pmodal__label E-mail
          input.pmodal__input(
            type="email"
            placeholder="seu@email.com"
            v-model="editEmail"
          )
          label.pmodal__label Nova senha
          input.pmodal__input(
            type="password"
            placeholder="Deixe em branco para manter"
            v-model="editPassword"
          )
          label.pmodal__label Confirme a nova senha
          input.pmodal__input(
            type="password"
            placeholder="Repita a nova senha"
            v-model="editPasswordConfirm"
          )
          p.pmodal__err(v-if="profileError") {{ profileError }}
          p.pmodal__ok(v-if="profileSuccess") Perfil atualizado!
          .pmodal__foot
            Button(
              text="Salvar"
              border="base"
              @click="doUpdateProfile"
            )

        .pmodal__step(v-if="step === 4")
          h3.pmodal__title Adicionar equipe
          label.pmodal__label Nome da equipe
          input.pmodal__input(
            type="text"
            v-model="teamName"
            placeholder="Digite o nome da equipe"
          )
          .pmodal__foot
            Button(
              text="Confirmar"
              border="base"
              @click="doCreateTeam"
            )

        .pmodal__step(v-if="step === 5")
          h3.pmodal__title Adicionar robô
          label.pmodal__label Nome do robô
          input.pmodal__input(
            type="text"
            placeholder="Digite o nome do robô"
            v-model="robotName"
          )
          label.pmodal__label Categoria
          Select.pmodal__select(
            defaultText="Selecionar categoria"
            :options="takeCategories"
            type='drop'
            @emit="doSetSelectedCategory"
          )
          label.pmodal__label Equipe
          Select.pmodal__select(
            defaultText="Selecionar equipe"
            :options="takeTeams"
            type='drop'
            @emit="doSetSelectedTeam"
          )
          p.pmodal__err(v-if="robotError") {{ robotError }}
          .pmodal__foot
            Button(
              text="Confirmar"
              border="base"
              @click="doCreateRobot"
            )

        .pmodal__step(v-if="step === 6")
          h3.pmodal__title Escolha seu nome de usuário
          p.pmodal__note Agora você pode entrar com um nome de usuário além do e-mail. Defina o seu para facilitar o login.
          label.pmodal__label Nome de usuário
          input.pmodal__input(
            type="text"
            placeholder="seunick"
            v-model="usernameInput"
            @keyup.enter="doSaveUsername"
          )
          p.pmodal__hint 3 a 20 caracteres: letras, números, . _ -
          p.pmodal__err(v-if="usernameError") {{ usernameError }}
          p.pmodal__ok(v-if="usernameSuccess") Nome de usuário salvo!
          .pmodal__foot
            Button(
              text="Salvar"
              border="base"
              @click="doSaveUsername"
            )
</template>

<script>
import {
  mapGetters,
  mapActions
} from 'vuex'

import {
  Button,
  Select,
  Check
} from '@/components/atoms'

import {
  Modal
} from '@/components/molecules'

import { downscaleImage } from '@/utils/image'

const ROLE_LABELS = {
  1: 'Admin',
  2: 'Inspetor de Segurança',
  3: 'Juiz de Combate',
  4: 'Juiz de Round',
  5: 'Pit Runner',
  6: 'Organizador'
}

const ROLE_ICONS = {
  Admin: ['fas', 'user-shield'],
  'Inspetor de Segurança': ['fas', 'shield-alt'],
  'Juiz de Combate': ['fas', 'gavel'],
  'Juiz de Round': ['fas', 'stopwatch'],
  'Pit Runner': ['fas', 'bolt'],
  Organizador: ['fas', 'user-tie']
}

export default {
  name: 'UserProfile',
  data: () => ({
    robotName: '',
    robotError: '',
    userId: '',
    permError: '',
    userRoles: [],
    showModal: false,
    selectedTeam: {},
    selectedCategory: {},
    teamName: '',
    step: 0,
    editName: '',
    editEmail: '',
    editPassword: '',
    editPasswordConfirm: '',
    profileError: '',
    profileSuccess: false,
    avatarImage: '',
    avatarChanged: false,
    usernameInput: '',
    usernameError: '',
    usernameSuccess: false
  }),
  created () {
    this.setUser({ user_id: this.getUser.id }).then(response => {
      if (this.getUser && !this.getUser.id) {
        this.$router.push('SignIn')
        return
      }
      this.setRoles()
      this.setTeams()
      this.setCategories()
      this.fetchUserImage(this.getUser.id).then(img => { this.avatarImage = img || '' })
      // Usuários antigos ainda não têm nick: pede para definir logo ao entrar.
      if (this.getUser.id && !this.getUser.username) {
        this.doShowModalUsername()
      }
    })
  },
  components: {
    Button,
    Select,
    Check,
    Modal
  },
  computed: {
    ...mapGetters('teams', [
      'getTeams'
    ]),
    ...mapGetters('categories', [
      'getCategories'
    ]),
    ...mapGetters('roles', [
      'getEventRoles'
    ]),
    ...mapGetters('users', [
      'getUser'
    ]),
    ...mapGetters('events', [
      'getCurrentEventId'
    ]),
    takeUser () {
      return this.getUser
    },
    userInitials () {
      const name = (this.takeUser && this.takeUser.name) || ''
      const parts = name.trim().split(/\s+/).filter(Boolean)
      if (!parts.length) return ''
      if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
      return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
    },
    takeTeams () {
      return [...this.getTeams].map(team => { return { text: team.name, value: team.id } })
    },
    takeCategories () {
      return [...this.getCategories].map(category => { return { text: category.name, value: category.id } })
    },
    takeRoles () {
      return this.getEventRoles
    },
    takePermissions () {
      const roles = (this.getUser && this.getUser.roles) || []
      return roles.map(role => ROLE_LABELS[role]).filter(Boolean)
    },
    canManage () {
      // Ações de gestão: Admin (1) do evento OU Organizador (6) global,
      // mesma regra do backend (generate_brackets) e da navbar (canManageEvent).
      const roles = (this.getUser && this.getUser.roles) || []
      return roles.includes(1) || roles.includes(6)
    },
    hasTeam () {
      return !!(this.getUser && this.getUser.team_id)
    },
    myTeam () {
      // getTeams inclui owner_id → capitania derivada sem chamada extra.
      return this.getTeams.find(t => t.id === (this.getUser && this.getUser.team_id)) || null
    },
    isCaptain () {
      return !!(this.myTeam && this.getUser && this.myTeam.owner_id === this.getUser.id)
    }
  },
  methods: {
    ...mapActions('robots', [
      'setRobots',
      'setCreateRobot'
    ]),
    ...mapActions('teams', [
      'setTeams',
      'setCreateTeam'
    ]),
    ...mapActions('categories', [
      'setCategories'
    ]),
    ...mapActions('roles', [
      'setRoles'
    ]),
    ...mapActions('users', [
      'setUser',
      'setAddEventRole',
      'setUpdateUser',
      'setUserImage',
      'setUsername',
      'fetchUserImage'
    ]),
    ...mapActions('fights', [
      'setGenerateKeys'
    ]),
    doNavigate (name) {
      if (name && name !== this.$route.name) {
        this.$router.push(name)
      }
    },
    permIcon (label) {
      return ROLE_ICONS[label] || ['fas', 'user']
    },
    doShowModalPermission () {
      this.step = 0
      this.showModal = true
    },
    doShowModalGenerateKeys () {
      this.step = 2
      this.showModal = true
    },
    doShowModalEditProfile () {
      this.step = 3
      this.profileError = ''
      this.profileSuccess = false
      this.editName = this.takeUser.name || ''
      this.editEmail = this.takeUser.email || ''
      this.editPassword = ''
      this.editPasswordConfirm = ''
      this.showModal = true
    },
    doSelectAvatar (e) {
      const files = e.target.files
      if (!files || !files.length) return
      const reader = new FileReader()
      reader.onload = () => {
        downscaleImage(reader.result).then(small => {
          this.avatarImage = small
          this.avatarChanged = true
        })
      }
      reader.readAsDataURL(files[0])
    },
    doUpdateProfile () {
      this.profileError = ''
      this.profileSuccess = false
      if (this.editPassword && this.editPassword !== this.editPasswordConfirm) {
        this.profileError = 'As senhas não conferem.'
        return
      }
      const payload = {}
      if (this.editName.trim()) payload.name = this.editName.trim()
      if (this.editEmail.trim()) payload.email = this.editEmail.trim()
      if (this.editPassword) payload.password = this.editPassword
      this.setUpdateUser(payload).then(response => {
        if (!response || !response.success) {
          this.profileError = (response && response.error) || 'Não foi possível salvar.'
          return null
        }
        // envia a foto (base64 cru) se trocada; o backend redimensiona
        if (this.avatarChanged && this.avatarImage) {
          return this.setUserImage({ image: this.avatarImage.split('base64,')[1] })
        }
        return true
      }).then(saved => {
        if (saved) {
          this.profileSuccess = true
          this.avatarChanged = false
          this.editPassword = ''
          this.editPasswordConfirm = ''
        }
      })
    },
    doShowModalUsername () {
      this.step = 6
      this.usernameInput = this.takeUser.username || ''
      this.usernameError = ''
      this.usernameSuccess = false
      this.showModal = true
    },
    doSaveUsername () {
      this.usernameError = ''
      this.usernameSuccess = false
      const username = (this.usernameInput || '').trim()
      if (!username) {
        this.usernameError = 'Informe um nome de usuário.'
        return
      }
      this.setUsername({ username }).then(response => {
        if (response && response.success) {
          this.usernameSuccess = true
          this.showModal = false
        } else {
          this.usernameError = (response && response.error) || 'Não foi possível salvar o nome de usuário.'
        }
      })
    },
    doShowModalAddTeam () {
      this.step = 4
      this.showModal = true
    },
    doShowModalAddRobot () {
      this.step = 5
      this.showModal = true
    },
    doSetModalVisibility (e) {
      this.showModal = e
    },
    doSetSelectedCategory (value) {
      this.selectedCategory = { ...value }
    },
    doSetSelectedTeam (value) {
      this.selectedTeam = { ...value }
    },
    doPassStep () {
      this.step = this.step + 1
    },
    doCreateRobot (e) {
      const robot = { name: this.robotName, class: this.selectedCategory.value, team: this.selectedTeam.value }
      this.robotError = ''
      // Nome repetido volta 200 com success:false: antes o modal fechava e o robô
      // simplesmente não existia.
      this.setCreateRobot(robot).then((res) => {
        if (!res || res.success === false) {
          this.robotError = (res && res.error) || 'Não foi possível cadastrar o robô.'
          return
        }
        this.robotName = ''
        this.showModal = false
      })
    },
    doGrantPermission () {
      this.permError = ''
      // O id vinha do input como STRING ("127") e o backend espera número —
      // resultava em 400 e o modal fechava sem avisar nada.
      const alvo = parseInt(this.userId, 10)
      if (!alvo) {
        this.permError = 'Informe um Id de usuário válido.'
        this.step = 0
        return
      }
      if (!this.userRoles.length) {
        this.permError = 'Selecione ao menos uma função.'
        return
      }
      if (!this.getCurrentEventId) {
        this.permError = 'Selecione um evento antes de conceder permissão.'
        return
      }
      const updateUserRoles = { user_id: alvo, role_ids: this.userRoles, admin_id: this.getUser.id, event_id: this.getCurrentEventId }
      this.setAddEventRole(updateUserRoles).then(res => {
        if (!res || res.success === false) {
          this.permError = (res && res.error) || 'Não foi possível conceder a permissão (verifique o Id e a sua permissão).'
          this.step = 0
          return
        }
        this.showModal = false
        this.permError = ''
        this.setUser({ user_id: this.getUser.id })
      })
    },
    doSetRoles (e) {
      if (e.checked) {
        this.userRoles = [...this.userRoles, e.value.id]
      } else {
        this.userRoles = this.userRoles.filter(role => role !== e.value.id)
      }
    },
    doCreateTeam () {
      const name = (this.teamName || '').trim()
      if (!name) return
      this.setCreateTeam({ name }).then(() => {
        this.showModal = false
        this.teamName = ''
        // recarrega o usuário (team_id agora setado → vira capitão) e navega
        return this.setUser({ user_id: this.getUser.id })
      }).then(() => this.doNavigate('MinhaEquipe'))
    },
    doGenerateKeys () {
      const categoryId = this.selectedCategory.value
      let arenaId = 2
      if (categoryId === 3) {
        arenaId = 1
      }
      this.setGenerateKeys({
        event_id: this.getCurrentEventId,
        category_id: categoryId,
        arena_id: arenaId,
        admin_id: this.getUser.id
      }).then(response => { if (response) { this.doSetModalVisibility(false) } })
    }
  },
  filters: {},
  watch: {}
}
</script>

<style lang="sass" scoped>
$blue: #287AED
$blue-dark: #0F4FA8
$red: #DD3434
$red-dark: #B0231F
$ink: #0B0E14
$muted: #5C6673
$line: rgba(11, 14, 20, 0.10)
$paper: #FFFFFF
$mist: #EEF1F6
$page: #F2F4F8

$display: 'Saira Condensed', 'Lato', sans-serif
$mono: 'Space Mono', 'Lato', monospace

.profile
  color: $ink
  background: $page
  min-height: calc(100vh - 64px)

  *
    box-sizing: border-box

  // ---------- HERO ----------
  &__hero
    position: relative
    overflow: hidden
    isolation: isolate
    padding: 40px 0 52px
    background: radial-gradient(circle at 16% 8%, #15233b 0%, $ink 52%, #05070b 100%)
    color: #fff

  &__hero-grid
    position: absolute
    inset: 0
    background-image: linear-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px)
    background-size: 42px 42px
    mask-image: radial-gradient(circle at 72% 6%, #000 0%, transparent 76%)
    -webkit-mask-image: radial-gradient(circle at 72% 6%, #000 0%, transparent 76%)
    z-index: -2

  &__hero-glow
    position: absolute
    width: 360px
    height: 360px
    border-radius: 50%
    filter: blur(110px)
    opacity: 0.5
    z-index: -1
    &--blue
      background: $blue
      top: -160px
      left: -90px
    &--red
      background: $red
      bottom: -190px
      right: -80px

  &__hero-inner
    position: relative
    max-width: 960px
    margin: 0 auto
    padding: 0 24px
    > *
      animation: pf-rise .6s cubic-bezier(.2, .7, .2, 1) both
    .profile__eyebrow
      animation-delay: .04s
    .profile__head
      animation-delay: .12s

  &__eyebrow
    display: inline-flex
    align-items: center
    gap: 10px
    font-family: $mono
    text-transform: uppercase
    letter-spacing: 0.22em
    font-size: 12px
    font-weight: 700
    color: rgba(255, 255, 255, 0.7)
    margin: 0 0 22px

  &__eyebrow-pip
    width: 8px
    height: 8px
    border-radius: 50%
    background: linear-gradient(135deg, #5AA0FF, $red)
    box-shadow: 0 0 0 4px rgba(40, 122, 237, 0.18)

  &__head
    display: flex
    align-items: center
    gap: 26px
    flex-wrap: wrap

  &__avatar
    flex-shrink: 0
    width: 104px
    height: 104px
    border-radius: 50%
    display: grid
    place-items: center
    font-family: $display
    font-weight: 700
    font-size: 40px
    text-transform: uppercase
    color: #fff
    background: linear-gradient(150deg, $blue, $blue-dark 55%, $red)
    border: 3px solid rgba(255, 255, 255, 0.16)
    box-shadow: 0 14px 36px rgba(0, 0, 0, 0.45)
    overflow: hidden

  &__avatar-img
    width: 100%
    height: 100%
    object-fit: cover

  &__identity
    min-width: 0

  &__name
    font-family: $display
    font-weight: 800
    text-transform: uppercase
    font-size: clamp(30px, 4.4vw, 48px)
    line-height: 0.98
    letter-spacing: -0.015em
    margin: 0

  &__meta
    display: flex
    flex-wrap: wrap
    align-items: center
    gap: 10px 18px
    margin: 14px 0 0
    color: rgba(255, 255, 255, 0.74)
    font-size: 14px

  &__meta-item
    display: inline-flex
    align-items: center
    gap: 8px
    word-break: break-all

  &__meta-ic
    color: #FF7A7A
    font-size: 13px

  &__id
    font-family: $mono
    font-size: 11px
    letter-spacing: 0.06em
    color: #9CC4FF
    background: rgba(40, 122, 237, 0.18)
    border-radius: 999px
    padding: 4px 11px

  &__roles
    display: flex
    flex-wrap: wrap
    gap: 8px
    margin: 18px 0 0

  &__role
    display: inline-flex
    align-items: center
    gap: 8px
    font-family: $mono
    font-size: 11px
    font-weight: 700
    text-transform: uppercase
    letter-spacing: 0.06em
    color: #fff
    background: rgba(255, 255, 255, 0.10)
    border: 1px solid rgba(255, 255, 255, 0.14)
    border-radius: 999px
    padding: 6px 13px
    &-ic
      font-size: 11px
      color: #6FB0FF
    &--muted
      color: rgba(255, 255, 255, 0.72)
      .profile__role-ic
        color: rgba(255, 255, 255, 0.55)

  // ---------- CORPO ----------
  &__wrap
    max-width: 960px
    margin: 0 auto
    padding: 40px 24px 64px

  &__section
    margin-bottom: 8px
    & + .profile__section
      margin-top: 36px

  &__section-title
    display: flex
    align-items: center
    gap: 12px
    font-family: $display
    text-transform: uppercase
    letter-spacing: 0.01em
    font-size: 22px
    font-weight: 700
    margin: 0 0 18px
    &::before
      content: ''
      width: 4px
      height: 20px
      border-radius: 2px
      background: linear-gradient(180deg, $blue, $red)

  // ---------- AÇÕES ----------
  &__actions
    display: grid
    grid-template-columns: repeat(auto-fill, minmax(min(100%, 280px), 1fr))
    gap: 14px

  // ---------- HINT (competidor) ----------
  &__hint
    display: flex
    align-items: center
    gap: 18px
    padding: 22px 24px
    background: $paper
    border: 1px solid $line
    border-radius: 16px
    flex-wrap: wrap
    &-ic
      display: grid
      place-items: center
      flex-shrink: 0
      width: 52px
      height: 52px
      border-radius: 12px
      font-size: 22px
      color: $blue
      background: rgba(40, 122, 237, 0.10)
    &-txt
      flex: 1 1 220px
      display: flex
      flex-direction: column
      gap: 4px
      strong
        font-family: $display
        text-transform: uppercase
        font-size: 19px
        font-weight: 700
        color: $ink
      span
        font-size: 14px
        color: $muted
    &-btn
      display: inline-flex
      align-items: center
      gap: 10px
      cursor: pointer
      font-family: $display
      font-weight: 600
      text-transform: uppercase
      letter-spacing: 0.06em
      font-size: 14px
      color: #fff
      background: $blue
      border: none
      border-radius: 6px
      padding: 11px 20px
      box-shadow: 0 10px 24px rgba(40, 122, 237, 0.32)
      transition: transform .18s ease, box-shadow .18s ease
      &:hover
        transform: translateY(-2px)
        box-shadow: 0 14px 30px rgba(40, 122, 237, 0.42)
      &-ic
        font-size: 12px

.actcard
  display: flex
  align-items: center
  gap: 16px
  text-align: left
  cursor: pointer
  font-family: inherit
  background: $paper
  border: 1px solid $line
  border-radius: 14px
  padding: 18px 20px
  transition: transform .22s ease, box-shadow .22s ease, border-color .22s ease
  &:hover
    transform: translateY(-4px)
    box-shadow: 0 18px 38px rgba(11, 14, 20, 0.12)
    border-color: rgba(40, 122, 237, 0.4)
    .actcard__arrow
      transform: translateX(4px)
      color: $blue
  &__ic
    display: grid
    place-items: center
    width: 46px
    height: 46px
    border-radius: 12px
    flex-shrink: 0
    font-size: 19px
    color: $blue
    background: rgba(40, 122, 237, 0.10)
  &:nth-child(even)
    .actcard__ic
      color: $red
      background: rgba(221, 52, 52, 0.10)
  &__txt
    flex: 1 1 auto
    min-width: 0
    display: flex
    flex-direction: column
    gap: 4px
    strong
      font-family: $display
      text-transform: uppercase
      font-size: 19px
      font-weight: 700
      line-height: 1
      color: $ink
    span
      font-size: 13px
      color: $muted
  &__arrow
    flex-shrink: 0
    font-size: 13px
    color: #C4C9D2
    transition: transform .22s ease, color .22s ease

// ---------- MODAL ----------
::v-deep .modal
  border-radius: 14px

.pmodal
  padding: 36px 32px 30px
  max-height: 78vh
  overflow-y: auto

  &__step
    display: flex
    flex-direction: column

  &__title
    font-family: $display
    font-weight: 700
    text-transform: uppercase
    font-size: 22px
    margin: 0 0 18px
    color: $ink

  &__label
    font-size: 13px
    font-weight: 600
    color: $muted
    margin: 12px 0 6px

  &__input
    border: none
    border-bottom: 1.5px solid $line
    padding: 8px 2px
    font-size: 15px
    font-family: inherit
    color: $ink
    &:focus
      outline: none
      border-color: $blue

  &__select
    margin: 4px 0

  &__checks
    display: flex
    flex-direction: column
    gap: 8px
    margin: 6px 0 4px

  &__photo
    display: flex
    align-items: center
    gap: 16px
    margin: 4px 0 10px

  &__photo-preview
    display: grid
    place-items: center
    flex-shrink: 0
    width: 72px
    height: 72px
    border-radius: 50%
    overflow: hidden
    font-size: 26px
    color: #fff
    background: linear-gradient(150deg, $blue, $blue-dark 55%, $red)
    img
      width: 100%
      height: 100%
      object-fit: cover

  &__photo-btn
    display: inline-flex
    align-items: center
    gap: 8px
    cursor: pointer
    font-family: $mono
    font-size: 12px
    font-weight: 700
    text-transform: uppercase
    letter-spacing: 0.04em
    color: $blue
    background: rgba(40, 122, 237, 0.08)
    border: 1px solid rgba(40, 122, 237, 0.28)
    border-radius: 8px
    padding: 9px 14px
    transition: background .18s ease
    &:hover
      background: rgba(40, 122, 237, 0.16)

  &__photo-input
    display: none

  &__note
    font-size: 14px
    color: $muted
    margin: 0 0 8px
    line-height: 1.45

  &__hint
    font-size: 12px
    color: $muted
    margin: 6px 0 0

  &__err
    font-size: 13px
    color: $red
    margin: 12px 0 0

  &__ok
    font-size: 13px
    color: #2E7D32
    margin: 12px 0 0

  &__foot
    margin-top: 26px

// ---------- animações ----------
@keyframes pf-rise
  from
    opacity: 0
    transform: translateY(16px)
  to
    opacity: 1
    transform: none

// ---------- responsivo ----------
@media (max-width: 620px)
  .profile__hero
    padding: 30px 0 38px
  .profile__hero-inner
    padding: 0 18px
  .profile__head
    gap: 18px
  .profile__avatar
    width: 84px
    height: 84px
    font-size: 32px
  .profile__wrap
    padding: 32px 18px 52px
</style>
